var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewtown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_MG\xE1\x84\x89\xE1\x85\xA2\xE1\x84\x86\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB3\xE1\x86\xAF\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x80\xE1\x85\xA9 1",
    clipPath: "url(#clip0_1736_9983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "#00326D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0832 15.6502C9.69908 15.65 9.32335 15.5379 9.00198 15.3275C8.6806 15.1171 8.42752 14.8176 8.27369 14.4657C8.11986 14.1137 8.07196 13.7245 8.13585 13.3458C8.19974 12.967 8.37264 12.6151 8.63341 12.3331C8.28223 11.6879 8.09884 10.9648 8.10007 10.2302C8.10007 10.1129 8.10474 9.99619 8.11385 9.88086C5.90274 10.7031 4.77719 13.1631 5.59985 15.3744C6.42252 17.5857 8.8803 18.7109 11.0916 17.8886C11.2856 17.8163 11.4741 17.7299 11.6556 17.6302V14.8715C11.4713 15.1137 11.2334 15.3101 10.9607 15.4451C10.6879 15.5802 10.3876 15.6504 10.0832 15.6502Z",
    fill: "url(#paint0_linear_1736_9983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.0829 11.6972C10.3003 11.6971 10.5163 11.7328 10.722 11.803C10.561 11.558 10.4523 11.2825 10.4026 10.9936C10.353 10.7047 10.3635 10.4087 10.4335 10.124C10.5035 9.83935 10.6314 9.57219 10.8094 9.33925C10.9873 9.10631 11.2114 8.9126 11.4677 8.77022C11.7239 8.62785 12.0068 8.53988 12.2985 8.51182C12.5903 8.48376 12.8848 8.5162 13.1634 8.60713C13.4421 8.69806 13.699 8.84551 13.9181 9.04027C14.1372 9.23502 14.3137 9.47289 14.4367 9.73899C15.2503 9.54546 16.1027 9.59452 16.8887 9.8801C16.6949 7.45655 14.5736 5.64877 12.15 5.84233C9.72647 6.03588 7.91781 8.15744 8.11136 10.581C8.1603 11.1948 8.33752 11.7915 8.63158 12.3325C8.81637 12.132 9.04077 11.972 9.29059 11.8626C9.54041 11.7532 9.81021 11.6969 10.0829 11.6972Z",
    fill: "url(#paint1_linear_1736_9983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.428 9.62305C15.0945 9.6231 14.7622 9.6621 14.4377 9.73927C14.5889 10.0683 14.6539 10.4305 14.6264 10.7916C14.599 11.1527 14.48 11.5008 14.2809 11.8033C14.6251 11.6862 14.995 11.6663 15.3498 11.7459C15.7046 11.8255 16.0305 12.0014 16.2918 12.2543C16.553 12.5073 16.7394 12.8274 16.8304 13.1794C16.9214 13.5315 16.9135 13.9018 16.8076 14.2496C16.7017 14.5975 16.5018 14.9094 16.23 15.1509C15.9582 15.3925 15.6251 15.5544 15.2672 15.6187C14.9093 15.6831 14.5406 15.6475 14.2017 15.5158C13.8627 15.3841 13.5667 15.1615 13.3462 14.8724V17.6299C15.4089 18.7753 18.0095 18.0315 19.1549 15.9688C20.3002 13.9062 19.5564 11.3055 17.4937 10.1602C16.8617 9.80923 16.1509 9.62442 15.428 9.62305Z",
    fill: "url(#paint2_linear_1736_9983)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1736_9983",
    x1: 9.13563,
    y1: 18.2131,
    x2: 7.66407,
    y2: 9.8673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#54C2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4FBCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3FACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2691D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#036BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1736_9983",
    x1: 7.81003,
    y1: 10.2179,
    x2: 16.0843,
    y2: 7.2061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#54C2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4FBCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3FACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2691D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#036BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1736_9983",
    x1: 17.3246,
    y1: 10.0055,
    x2: 15.8582,
    y2: 18.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#54C2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4FBCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3FACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2691D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#036BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068B6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_9983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewtown);
export default __webpack_public_path__ + "static/media/newtown.56b38d932c8903cbbc7f9783d2364220.svg";
export { ForwardRef as ReactComponent };